export default __webpack_public_path__ + "static/hero-souvenirs-68961e7c3d967069d95b0cb694949a6a.jpg";